module.exports = __webpack_public_path__ + "media/images/bg/shapes/hex-green-light-47943ed822569bad31176b77e67a0a7c.svg";